import { Component, input, Input, InputSignal } from '@angular/core';
import {
  OccupationOfLanePlacementConstructionObjectsForm
} from '../../forms/occupation-of-lane-placement-construction-objects.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  LocationDecisionsCrudComponent
} from '../../../../../common/components/location-decisions/location-decisions-crud/location-decisions-crud.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import {
  OccupationOfLanePlacementConstructionObjectsStageFormComponent
} from '../occupation-of-lane-placement-construction-objects-stage-form/occupation-of-lane-placement-construction-objects-stage-form.component';

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    LocationDecisionsCrudComponent,
    TabPanelComponent,
    TabViewComponent,
    OccupationOfLanePlacementConstructionObjectsStageFormComponent
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-form.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsFormComponent {

  public serviceId: InputSignal<string | null> = input<string | null>(null);

  @Input()
  public form: OccupationOfLanePlacementConstructionObjectsForm | undefined;
}
